import { forwardRef, useState, useEffect } from "react";
import * as S from "./navbar.styles";
import { Container } from "../container/container.layout";
import { DesktopContent } from "./variants/desktop-content/desktop-content";
import { MobileContent } from "./variants/mobile-content/mobile-content";
import { useCart } from "../../hooks/use-cart-hook";

export const Navbar = forwardRef<HTMLDivElement>((_, ref) => {
  const [scrolled, setScrolled] = useState(false);
  const isDesktop = typeof window !== "undefined" ? window.innerWidth >= 1024 : false;
  const { toggleCart } = useCart();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 0);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <S.Nav scrolled={scrolled} ref={ref}>
      <Container>
        {
          isDesktop ? <DesktopContent toggleCart={toggleCart} /> : <MobileContent />
        }
      </Container>
    </S.Nav>
  );
});
